import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';

export class HdfsCommandWrapper extends DatabaseWrapper {

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.dfs.ID;
        this.name = DatabaseEnum.dfs.NAME;
        this.code = DatabaseEnum.dfs.CODE;
        this.equivalentTag = DatabaseEnum.dfs.EQUIVALENT_TAG;
        //data object tabs
        this.showDataObjectPropertiesTab = true;
        this.isShowObjProperties = false;
        this.isFileType = true;
        this.showPropertiesTab = false;
        this.importFileProperties();
        this.showTruncBeforeField = true;
        this.showExtractProperties = false;
        this.extractPropertiesLabel = 'Properties';
        this.loadPropertiesLabel = 'Properties';
        this.showDataDescription = false;
    }

    importFileProperties() {
        this.showFileTypeGroup = true;
        this.showParquet = true;
        this.showDelimiter = true;
        this.showFixedWidth = true;
    }

    readFileCutOffLength(type: string): number {
        if( type == "FILE" ){
            return 49; //default 50 lines index starts from 0
        }

        return -1;
    }

}
